var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPageStaredFirst(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1703,
    height: 980,
    viewBox: "0 0 1703 980",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2104_7605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441 827.28C263.607 843.652 0 931.96 0 931.96V0H1703V793.246C1703 793.246 1397.86 912.502 1186.5 931.96C893.746 958.911 733.748 800.261 441 827.28Z",
    fill: "#ECFBFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 0C35 61.5 84.7 145.4 167.5 185C271 234.5 243.587 383.03 322.5 450C415 528.5 545 411 487 290.5C455.448 224.949 469.5 202.5 487 185C504.5 167.5 593 167.5 644.5 279.5C696 391.5 769.5 299 769.5 299C769.5 299 898.638 153.903 968 204.5C1017.89 240.896 973.53 306.256 1008 357.5C1059.52 434.087 1202.5 400.5 1219.5 463C1236.5 525.5 1275 680.5 1357 618C1439 555.5 1405.5 322.5 1486 322.5C1566.5 322.5 1475.72 523.468 1566.5 555.5C1619.26 574.116 1677.67 548 1708.5 536.5",
    stroke: "#D7E9FF",
    strokeWidth: 25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2104_7605",
    x: -10,
    y: -8,
    width: 1723,
    height: 955.055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2104_7605"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2104_7605",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageStaredFirst);
export default __webpack_public_path__ + "static/media/PageStaredFirst.2d7447b8b0806e2fa0bd80b1f48595d5.svg";
export { ForwardRef as ReactComponent };